<template>
  <div class="section">
    <form class="container" method="post" @submit.prevent="submitData">
      <div class="field">
        <label class="label">Email</label>
        <div class="control has-icons-left">
          <span class="icon is-small is-left">
            <i class="fa fa-user"></i>
          </span>
          <input v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('email')}" type="email" name="email"
            placeholder="Email" v-model="email">
          <span v-show="errors.has('email')" class="help is-danger" v-text="errors.first('email')"></span>
        </div>
      </div>
      <div class="field">
        <label class="label">Password</label>
        <div class="control has-icons-left">
          <span class="icon is-small is-left">
            <i class="fa fa-key"></i>
          </span>
          <input v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('password')}" type="password" name="password"
            placeholder="Password" v-model="password">
          <span v-show="errors.has('password')" class="help is-danger" v-text="errors.first('password')"></span>
        </div>
      </div>
      <div class="field">
        <router-link to="/forgot_password">Forgot Password?</router-link>
      </div>
      <div class="control">
        <button type="submit" class="button is-primary">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import Fingerprint2 from 'fingerprintjs2'
export default {
  data () {
    return {
      email: '',
      password: '',
      fingerprint: ''
    }
  },
  created () {
    if (this.getSessionItem('access_token') !== null) {
      this.$router.push('/panel/profile')
    }
    var self = this
    new Fingerprint2().get(function (result, components) {
      self.fingerprint = result
    })
  },
  methods: {
    submitData () {
      this.$validator.validateAll()
      .then((result) => {
        if (result) {
          var self = this
          self.$geb.emit({id: 'preloader', eventData: true})
          self.flyPost('login', {
            email: self.email,
            password: self.password,
            type: 1,
            fingerprint: self.fingerprint
          })
          .then(function (response) {
            self.$geb.emit({id: 'preloader', eventData: false})
            if (response.data.response_code === 1) {
              self.setSessionItem('id_token', response.data.data.id_token)
              self.setSessionItem('access_token', response.data.data.access_token)
              if (response.data.data.device_status_flag === 1) {
                self.$router.push('/panel/profile')
              } else {
                self.$router.push('/device_check')
              }
            } else if (response.data.response_code === -1) {
              self.removeSessionItem('id_token')
              self.removeSessionItem('access_token')
              self.$router.push('/')
            } else {
              var result = response.data.message
              for (var name in response.data.message) {
                self.errors.add(name, result[name])
              }
            }
          })
          .catch(function (error) {
            self.errorMessage(error)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue